module.exports = __webpack_public_path__ + "img/img_default.4ed76cad.png";